import { MEDIA_QUERIES } from "../utils/breakpoints.js";
gsap.registerPlugin(ScrollTrigger);

export function initTopFunctions() {
    const kvTl = gsap.timeline({ delay: 0.5 });
    const kvElementsTl = gsap.timeline({ delay: 0.5 });

    // kv animation
    (function () {
        const paths = document.querySelectorAll(".top__kv__img .kvRibbon svg path");
        if (paths.length) {
            const speed = 2200;

            paths.forEach((path) => {
                const len = path.getTotalLength();

                // Positive offsets only (Safari breaks on negative stroke-dashoffset).
                // len → 2*len draws reverse, same as the old -len → 0.
                gsap.set(path, {
                    strokeDasharray: len,
                    strokeDashoffset: len,
                    opacity: 1,
                });

                kvTl.to(path, {
                    strokeDashoffset: len * 2,
                    duration: len / speed,
                    ease: "power1.inOut",
                }, 0);
            });
        }

        const textEls = document.querySelectorAll(".top__kv__textEn .js-animatedText");
        
        if (textEls.length) {
            gsap.set(textEls, {
                opacity: 0,
                y: 12,
            });

            kvTl.to(
                textEls,
                {
                    opacity: 1,
                    y: 0,
                    duration: 0.8,
                    ease: "power1.out",
                    stagger: 0.12,
                },
                0.8
            );
        }

        const container = document.querySelector(".top__kv__img");

        const KV_MOVE_FACTOR = 0.15;
        const KV_START_SCALE = 0.6;
        const KV_CHARACTER_SCALE_DOWN = 1;
        const KV_CHARACTER_SCALE_DURATION = 0;

        const resolveTransformOrigin = (scaleOrigin) =>
            !scaleOrigin || scaleOrigin === "center" ? "50% 50%" : scaleOrigin;

        const kvElementAnimations = [
            { selector: ".BgLeafElement01", start: 1.2, duration: 1.1, rotation: 0, scaleOrigin: "left bottom" },
            { selector: ".blueElment", start: 1.6, duration: 1.0, rotation: 0, scaleOrigin: "right bottom" },
            { selector: ".statueElement", start: 1.5, duration: 1.0, rotation: 0, scaleOrigin: "right bottom" },
            { selector: ".windowElement", start: 1.6, duration: 1.0, rotation: 1.5, scaleOrigin: "left top" },
            { selector: ".BgLeafElement02", start: 1.3, duration: 1.0, rotation: 0, scaleOrigin: "right top" },
            { selector: ".flowerElement", start: 1.3, duration: 1.0, rotation: 0, scaleOrigin: "center top" },
            { selector: ".ringElement", start: 1.4, duration: 1.0, rotation: 0, scaleOrigin: "top bottom" },
            { selector: ".redDotElement01", start: 1.8, duration: 0.8, rotation: 0, scaleOrigin: "left center" },
            { selector: ".redDotElement02", start: 1.7, duration: 0.8, rotation: 0, scaleOrigin: "left center" },
        ];

        const kvElementSlideChangeAnimations = [
            { selector: ".blueElment", duration: 0, rotation: 0, scaleOrigin: "right bottom" },
            { selector: ".statueElement", duration: 0, rotation: 0, scaleOrigin: "right bottom" },
            { selector: ".windowElement", duration: 0, rotation: 0, scaleOrigin: "left bottom" },
            { selector: ".BgLeafElement01", duration: 0, rotation: 0, scaleOrigin: "left bottom" },
            { selector: ".BgLeafElement02", duration: 0, rotation: 0, scaleOrigin: "right top" },
            { selector: ".flowerElement", duration: 0, rotation: 0, scaleOrigin: "center top" },
            { selector: ".ringElement", duration: 0, rotation: 0, scaleOrigin: "top bottom" },
            { selector: ".redDotElement01", duration: 0, rotation: 0, scaleOrigin: "left center" },
            { selector: ".redDotElement02", duration: 0, rotation: 0, scaleOrigin: "left center" },
        ];

        const playKvElementRotation = (element, rotation, duration, scaleOrigin = "center") => {
            if (!element || !rotation) return;

            gsap.set(element, {
                transformOrigin: resolveTransformOrigin(scaleOrigin),
            });

            gsap.timeline({ overwrite: "auto" })
                .to(element, {
                    rotation,
                    duration: duration * 0.35,
                    ease: "sine.out",
                })
                .to(element, {
                    rotation: 0,
                    duration,
                    ease: "sine.out",
                });
        };

        const playKvElementsRotationOnSlideChange = () => {
            if (!container) return;

            kvElementSlideChangeAnimations.forEach(({ selector, rotation, duration, scaleOrigin }) => {
                playKvElementRotation(
                    container.querySelector(selector),
                    rotation,
                    duration,
                    scaleOrigin,
                );
            });
        };

        const startKvCharacterSlider = (characterEl) => {
            const flipEl = characterEl.querySelector(".characterImg__flip");
            const sliderEl = characterEl.querySelector(".js-kvCharacterSlider");

            if (!flipEl || !sliderEl || typeof Swiper === "undefined") return;

            gsap.set(flipEl, {
                scale: 1,
                transformOrigin: "50% 50%",
            });

            const swiper = new Swiper(sliderEl, {
                loop: true,
                effect: "fade",
                fadeEffect: {
                    crossFade: true,
                },
                speed: 4000,
                allowTouchMove: false,
            });

            let isAnimating = false;

            const animateCharacterOnSlideChange = () => {
                if (isAnimating) return;
                isAnimating = true;

                gsap.timeline({
                    onComplete: () => {
                        gsap.set(flipEl, { scale: 1 });
                        isAnimating = false;
                    },
                })
                    .to(flipEl, {
                        scale: KV_CHARACTER_SCALE_DOWN,
                        duration: KV_CHARACTER_SCALE_DURATION,
                        // opacity: 0.9,
                        ease: "sine.inOut",
                    })
                    .add(() => {
                        playKvElementsRotationOnSlideChange();
                    }, KV_CHARACTER_SCALE_DURATION * 0.35)
                    .add(() => {
                        swiper.slideNext();
                    }, KV_CHARACTER_SCALE_DURATION)
                    .to(
                        flipEl,
                        {
                            scale: 1,
                            duration: KV_CHARACTER_SCALE_DURATION,
                            // opacity: 1,
                            ease: "sine.inOut",
                        },
                        KV_CHARACTER_SCALE_DURATION,
                    );
            };

            gsap.delayedCall(4, function loop() {
                animateCharacterOnSlideChange();
                gsap.delayedCall(6, loop);
            });
        };

        const character = document.querySelector(".top__kv__img .characterImg");
        const characterFlip = character?.querySelector(".characterImg__flip");
        if (character && characterFlip) {
            gsap.set(character, {
                opacity: 0,
                scale: KV_START_SCALE,
            });
            gsap.set(characterFlip, {
                scale: 1,
                transformOrigin: "50% 50%",
            });

            kvTl.to(
                character,
                {
                    opacity: 1,
                    scale: 1,
                    duration: 1.2,
                    ease: "power1.out",
                    onComplete: () => startKvCharacterSlider(character),
                },
                1.0,
            );
        }

        const animateKvElement = (
            element,
            timeline,
            position,
            duration,
            rotation = 0,
            scaleOrigin = "center",
        ) => {
            if (!container || !element) return;

            const transformOrigin = resolveTransformOrigin(scaleOrigin);
            const fromCenter = transformOrigin === "50% 50%";

            let offsetX = 0;
            let offsetY = 0;

            if (fromCenter) {
                const containerRect = container.getBoundingClientRect();
                const elRect = element.getBoundingClientRect();

                offsetX =
                    containerRect.left +
                    containerRect.width / 2 -
                    (elRect.left + elRect.width / 2);
                offsetY =
                    containerRect.top +
                    containerRect.height / 2 -
                    (elRect.top + elRect.height / 2);
            }

            gsap.set(element, {
                scale: KV_START_SCALE,
                opacity: 0,
                x: offsetX * KV_MOVE_FACTOR,
                y: offsetY * KV_MOVE_FACTOR,
                rotation: 0,
                transformOrigin,
            });

            timeline.to(
                element,
                {
                    scale: 1,
                    opacity: 1,
                    x: 0,
                    y: 0,
                    duration: duration,
                    ease: "sine.out",
                },
                position,
            );

            if (!rotation) return;

            const rotateStart = position + duration * 0.65;

            timeline.to(
                element,
                {
                    rotation: rotation,
                    duration: 0.35,
                    ease: "sine.out",
                },
                rotateStart,
            );

            timeline.to(
                element,
                {
                    rotation: 0,
                    duration: 0.7,
                    ease: "sine.out",
                },
                rotateStart + 0.35,
            );
        };

        kvElementAnimations.forEach(({ selector, start, duration, rotation, scaleOrigin }) => {
            animateKvElement(
                document.querySelector(`.top__kv__img ${selector}`),
                kvElementsTl,
                start,
                duration,
                rotation,
                scaleOrigin,
            );
        });

        const textJaEls = document.querySelectorAll(".top__kv__textJa .js-animatedText");
        
        if (textJaEls.length) {
            gsap.set(textJaEls, {
                opacity: 0,
                y: 12,
            });

            kvTl.to(
                textJaEls,
                {
                    opacity: 1,
                    y: 0,
                    duration: 0.7,
                    ease: "power1.out",
                    stagger: 0.12,
                },
                2
            );
        }

    })();

    //slider
    const topSliders = document.querySelectorAll(".js-topSlider");

    const getTopSliderSlidesPerView = () => {
        const w = window.innerWidth;
        if (w >= 2000) return 5;
        if (w >= 1000) return 4;
        if (w >= 769) return 3;
        return 1.2;
    };

    topSliders.forEach((el) => {
        let swiper = null;
        const slideCount = el.querySelectorAll(".swiper-slide").length;
        const nextBtn = el.querySelector(".top__slider__nav--next");
        const prevBtn = el.querySelector(".top__slider__nav--prev");

        const canLoop = () => slideCount > Math.ceil(getTopSliderSlidesPerView());

        if (nextBtn) {
            nextBtn.addEventListener("click", (e) => {
                if (!swiper) return;
                e.preventDefault();
                e.stopPropagation();
                swiper.wrapperEl.style.transitionDuration = "0ms";
                swiper.slideNext(400, true);
            });
        }
        if (prevBtn) {
            prevBtn.addEventListener("click", (e) => {
                if (!swiper) return;
                e.preventDefault();
                e.stopPropagation();
                swiper.wrapperEl.style.transitionDuration = "0ms";
                swiper.slidePrev(400, true);
            });
        }

        const initSwiper = () => {
            if (swiper) return;
            el.classList.remove("is-static");
            swiper = new Swiper(el, {
                loop: true,
                initialSlide: 0,
                speed: 1200,
                autoplay: {
                    delay: 3000,
                    disableOnInteraction: false,
                },
                allowTouchMove: true,
                slidesPerView: 1.2,
                spaceBetween: 30,
                pagination: {
                    el: el.querySelector(".top__slider__pagination"),
                    clickable: true,
                },
                breakpoints: {
                    769: { slidesPerView: 3, spaceBetween: 30 },
                    1000: { slidesPerView: 4, spaceBetween: 45 },
                    2000: { slidesPerView: 5, spaceBetween: 45 },
                },
            });
            el.classList.add("is-ready");
        };

        const destroySwiper = () => {
            if (!swiper) return;
            swiper.destroy(true, true);
            swiper = null;
            el.classList.remove("is-ready");
            el.classList.add("is-static");
        };

        const update = () => {
            if (canLoop()) {
                initSwiper();
            } else {
                destroySwiper();
                el.classList.add("is-static");
            }
        };

        update();

        let resizeTimer;
        let currentWindowWidth = window.innerWidth;
        window.addEventListener("resize", () => {
            clearTimeout(resizeTimer);
            resizeTimer = setTimeout(() => {
                if (currentWindowWidth === window.innerWidth) return;
                currentWindowWidth = window.innerWidth;
                update();
            }, 200);
        });
    });

    //campus life slider
    (function () {
        const swiper = new Swiper(".js-campusLifeSlider", {
            loop: true,
            spaceBetween: 30,
            slidesPerView: "auto",
            speed: 5000,
            allowTouchMove: false,
            rtl: true,
            autoplay: {
                delay: 0,
                disableOnInteraction: false,
            },
            breakpoints: {
                769: {
                    spaceBetween: 30,
                    centeredSlides: false,
                },
                1000: {
                    spaceBetween: 45,
                    centeredSlides: false,
                },
            },
        });
    })();

    //ribbon
    (function () {
        const mm = gsap.matchMedia();
        const containers = document.querySelectorAll(".js-ribbonContainer");
        const mobileRibbonContainers = document.querySelectorAll(
            ".js-mobileRibbonContainer",
        );

        containers.forEach((container) => {
            mm.add(
                {
                    isDesktop: `(min-width: 769px)`,
                    isMobile: `(max-width: 768px)`,
                },
                (context) => {
                    let { isDesktop } = context.conditions;
                    const selector = isDesktop
                        ? ".js-ribbon:not(.modBpSp) path"
                        : ".js-ribbon:not(.modBpPc) path";
                    const ribbonNodes = container.querySelectorAll(selector);

                    if (ribbonNodes.length === 0) return;

                    let ribbons = Array.from(ribbonNodes);

                    if (isDesktop) {
                        ribbons.reverse();
                    }

                    const tl = gsap.timeline({
                        scrollTrigger: {
                            trigger: container,
                            start: `top ${isDesktop ? "70%" : "90%"}`,
                            end: `bottom ${isDesktop ? "40%" : "45%"}`,
                            toggleActions: "play none none reverse",
                            // markers: true,
                        },
                    });

                    const speed = isDesktop ? 1600 : 1000;

                    ribbons.forEach((ribbon) => {
                        const len = ribbon.getTotalLength();
                        const duration = len / speed;

                        gsap.set(ribbon, {
                            strokeDasharray: len,
                            strokeDashoffset: len,
                            opacity: 1,
                        });

                        tl.to(ribbon, {
                            strokeDashoffset: 0,
                            ease: "power2.inOut",
                            duration: duration,
                        });
                    });

                    return () => {
                        tl.kill();
                    };
                },
            );
        });

        mm.add("(max-width: 768px)", () => {
            mobileRibbonContainers.forEach((container) => {
                const mobileRibbon = container.querySelector(".js-mobileRibbon path");

                if (!mobileRibbon || typeof mobileRibbon.getTotalLength !== "function")
                    return;

                const len = mobileRibbon.getTotalLength();

                gsap.set(mobileRibbon, {
                    strokeDasharray: len,
                    strokeDashoffset: len,
                    opacity: 1,
                });

                const speed = 1000;
                const duration = len / speed;

                gsap.to(mobileRibbon, {
                    strokeDashoffset: 0,
                    ease: "power2.inOut",
                    duration: duration,
                    scrollTrigger: {
                        trigger: container,
                        start: "top 90%",
                        end: "bottom 45%",
                        toggleActions: "play none none reverse",
                    },
                });
            });
        });
    })();
    
    // float btn
    (function () {
        const floatBtn = document.querySelector(".js-floatBtn");
        const footer = document.querySelector("footer");
        if (!floatBtn) return;

        let isInsideFooter = false;

        const toggleFloatBtn = () => {
            if (isInsideFooter) {
                floatBtn.classList.remove("is-show");
                return;
            }
            if (window.scrollY > 100) {
                floatBtn.classList.add("is-show");
            } else {
                floatBtn.classList.remove("is-show");
            }
        };

        window.addEventListener("scroll", toggleFloatBtn);
        toggleFloatBtn(); 

        if (footer) {
            ScrollTrigger.create({
                trigger: footer,
                start: "top bottom",
                end: "bottom bottom",
                onEnter: () => {
                    isInsideFooter = true;
                    floatBtn.classList.remove("is-show");
                },
                onLeave: () => {
                    isInsideFooter = true;
                    floatBtn.classList.remove("is-show");
                },
                onEnterBack: () => {
                    isInsideFooter = true;
                    floatBtn.classList.remove("is-show");
                },
                onLeaveBack: () => {
                    isInsideFooter = false;
                    toggleFloatBtn();
                }
            });
        }
    })();
}
